// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lq-0";